var _style, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D80027;}\n\t.st1{fill:#6DA544;}\n\t.st2{fill:#338AF3;}\n\t.st3{fill:#F0F0F0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,256c0-31.3-5.6-61.3-15.9-89L256,155.8L15.9,167C5.6,194.7,0,224.7,0,256s5.6,61.3,15.9,89L256,356.2 L496.1,345C506.4,317.3,512,287.3,512,256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c110.1,0,203.9-69.5,240.1-167H15.9C52.1,442.5,145.9,512,256,512z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.9,167h480.2C459.9,69.5,366.1,0,256,0S52.1,69.5,15.9,167z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M261.6,328.3c-40,0-72.3-32.4-72.3-72.3s32.4-72.3,72.3-72.3c12.5,0,24.2,3.1,34.4,8.7 c-16.1-15.7-38-25.4-62.2-25.4c-49.2,0-89,39.9-89,89s39.9,89,89,89c24.2,0,46.2-9.7,62.2-25.4C285.7,325.2,274,328.3,261.6,328.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317.2,205.9l9.6,27l25.8-12.3l-12.3,25.8l27,9.6l-27,9.6l12.3,25.8l-25.8-12.3l-9.6,27l-9.6-27l-25.8,12.3 l12.3-25.8l-27-9.6l27-9.6l-12.3-25.8l25.8,12.3L317.2,205.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAz);
export default __webpack_public_path__ + "static/media/az.d708a544723611df21b3893f652c3c5f.svg";
export { ForwardRef as ReactComponent };